export default __webpack_public_path__ + "static/media/empty-state-programs.779baf88.svg";